export const SET_LOADING = 'SET_LOADING';
export const SAVE_USER = 'SAVE_USER';
export const LOGOUT = 'LOGOUT';

export const SAVE_FCM = 'SAVE_FCM';
export const SAVE_CHAT = 'SAVE_CHAT';
export const SAVE_LIST = 'SAVE_LIST';
export const SHOW_POPUP = 'SHOW_POPUP';